import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AssigneeSelect from "../../../../clients/board/client-profile/components/shared/assignee-select";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AssigneesArgument",
  components: {
    AssigneeSelect
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    boardId: {
      type: [String, Number],
      required: true
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const localValue = this.value;
    return {
      localValue
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
    },
    localValue() {
      this.$emit("input", this.localValue);
    }
  },
  methods: {
    handleNotifyChange(data, type) {
      if (type === "select") {
        this.localValue = this.multiple ? _mapInstanceProperty(data).call(data, item => item.username) : [data.username];
      } else if (type === "unselect") {
        var _context;
        this.localValue = _filterInstanceProperty(_context = this.localValue).call(_context, username => username !== data.username);
      } else if (type === "clear") {
        this.localValue = [];
      }
    }
  }
});